import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  CHOOSE_PLAN: {
    path: `${baseRoutes.userBaseRoutes}choose-plan`,
  },
};

export default accessRoute;
